import { createMetricsFactory } from 'metrics-js';
export const Metrics = createMetricsFactory('pricing-pages-ui');
export const trackPricingPagePql = app => {
  if (app && app === 'pricing-pages') {
    Metrics.counter('talk-to-sales-pql').increment();
  }
};